import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M18.141 7.636c2.245 0 4.065-1.71 4.065-3.818S20.386 0 18.141 0c-2.244 0-4.064 1.71-4.064 3.818 0 2.109 1.82 3.818 4.064 3.818Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M25.461 18H10.823c-.314 0-.563-.257-.537-.557.775-7.81 6.322-8.164 7.856-8.17 1.535.006 7.082.36 7.857 8.17a.526.526 0 0 1-.538.557Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("rect", {
      width: "10.297",
      height: "2.077",
      y: "7.615",
      fill: "#fff",
      rx: "1.038"
    }, null, -1),
    _createElementVNode("rect", {
      width: "10.385",
      height: "2.059",
      x: "6.179",
      y: "3.461",
      fill: "#fff",
      rx: "1.03",
      transform: "rotate(90 6.179 3.461)"
    }, null, -1)
  ]))]))
}
export default { render: render }